module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-28.dacbc988.png";